import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './index.scss';
import Button from '../Button';

const cx = classNames.bind(styles);

const Stats = [
  {
    title: 'Codecs',
    key: 'codecs',
    unit: '',
  },
  {
    title: 'Stream bitrate',
    key: 'bitrate',
    unit: 'Kbps',
  },
  {
    title: 'Viewport',
    key: 'viewport',
    unit: '',
  },
  {
    title: 'Stream resolution',
    key: 'resolution',
    unit: '',
  },
];

const StreamStats = props => (
  <div className={cx('StreamStats')}>
    <Button onClick={props.close} color="transparent" className={cx('StreamStats__Close')} type="button" title="close">[X]</Button>
    {Stats.map(stat => (
      <div className={cx('StreamStats__Stat')}>
        <div className={cx('StreamStats__Stat__Title')}>
          {stat.title}
          :
        </div>
        <span className={cx('StreamStats__Stat__Value')}>
          {props[stat.key]}
          {' '}
          {stat.unit}
        </span>
      </div>
    ))}
  </div>
);

StreamStats.propTypes = {
  bitrate: PropTypes.number,
  resolution: PropTypes.string,
  codecs: PropTypes.string,
  viewport: PropTypes.string,
  close: PropTypes.func.isRequired,
};

export default StreamStats;
